module.exports = __webpack_public_path__ + "img/dna-crypto.81ac0620.png";